import React from 'react'

import {
  ReportingFilters,
  type ReportingFiltersProps,
} from './ReportingFilters'

type InboundAnswerRateFiltersProps = Omit<
  ReportingFiltersProps,
  'titleKey' | 'titleFallback' | 'subtitleKey' | 'subtitleFallback'
>

export const InboundAnswerRateFilters = (
  props: InboundAnswerRateFiltersProps,
) => (
  <ReportingFilters
    titleKey="inboundAnswerRate.header"
    titleFallback="Inbound Answer Rate"
    subtitleKey="inboundAnswerRate.subtitle"
    subtitleFallback="Displays the percentage of inbound calls answered"
    {...props}
  />
)
